<!--
  @name: 推广新闻
  @author: dgq
  @time:
-->
<template>
	<basic-container>
		<avue-crud
			v-model="formData"
			:page.sync="page"
			v-bind="bindVal"
			v-on="onEvent"
			@on-load="getList"
			@refresh-change="refreshChange"
			@search-reset="searchChange"
			@search-change="searchChange"></avue-crud>
	</basic-container>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {mapGetters} from 'vuex'

const option = {
	//模块名字
	name: 'businessFollower',
	optionPath: 'team/place',
	optionNameList: ['businessFollowerOption'],
	apiPath: 'team/place',
	//接口名字
	apiNameList: ['getBusinessFollower'],
	apiNameAddList: ['addBusinessFollower'],
	apiNameUpdateList: ['editBusinessFollower'],
	apiNameDelList: ['delBusinessFollower'],
	//如有时间搜索，则必填，例如['payTime','payTimeStart','payTimeEnd']
	searchData: [],
	//主键
	rowKey: 'id',
}
export default window.$baseCrud(
	{
		created() {},
		data() {
			return {}
		},
		computed: {
			...mapGetters(['permissions']),
		},
		mounted() {},
		methods: {
			//可以重写getList() {},
			//列表前操作方法
			listBefore() {},
			//列表后操作方法
			listAfter() {},
			//请求错误
			listError() {},
			//请求finally
			listFinally() {},
			//删除数据
			rowDel(row, index) {
				this.$confirm(`此操作将永久删除这条数据，是否继续`, '提示', {
					confirmButtonText: '确定',
				})
					.then(() => {
						//删除
						let delReqData = this.delReqData(row)
						if (this.validatenull(delReqData)) {
							this.$message.error('请求参数有误')
							return
						}
						let {apiNameDelList} = option
						return this.api[apiNameDelList ? apiNameDelList[this.currentIndex] : 'del'](delReqData)
					})
					.then(() => {
						//刷新数据
						this.getList()
						this.$message.success('删除成功')
					})
					.catch(() => {})
			},
			//额外添加请求参数
			addRequestData() {},
			onCreated(editor) {},
		},
	},
	option,
)
</script>

<style lang="scss" scoped></style>
